const { rideStatusMapping } = relaylib.ride;
const statuses = relaylib.ride.status;
angular.module('relayHealth').controller('inProgressDetailsCtrl', [
  '$scope',
  '$rootScope',
  '$http',
  'API_BASE_URL',
  'rideDetails',
  '$uibModalInstance',
  'Pubnub',
  'pubnubNotificationFactory',
  'SweetAlert',
  '$timeout',
  'toaster',
  '$state',
  'caller',
  'loadingScreenFactory',
  'checkAndClearETA',
  'isOCCMRole',
  'permissionFilter',
  '$uibModal',
  'orgHierarchyFactory',
  'ngDialog',
  async function inProgressDetailsCtrl(
    $scope,
    $rootScope,
    $http,
    API_BASE_URL,
    rideDetails,
    $uibModalInstance,
    Pubnub,
    pubnubNotificationFactory,
    SweetAlert,
    $timeout,
    toaster,
    $state,
    caller,
    loadingScreenFactory,
    checkAndClearETA,
    isOCCMRole,
    permissionFilter,
    $uibModal,
    orgHierarchyFactory,
    ngDialog,
  ) {
    loadingScreenFactory.hideLoadingScreen();
    $scope.permissionsConstants = relaylib.permissions.permissionsConstants;
    $scope.ride_status = relaylib.ride.status;
    $scope.providerMapping = relaylib.common.constants.providerIdMapping;
    $scope.oldDashboard = rideDetails.oldDashboard;
    $scope.isMasRide = rideDetails.appointment.organisation.org_type === 'mas';
    $scope.isGHTRide = rideDetails.appointment.organisation.market_segment.key === 'GHT';
    // $scope.isMasRide = true;
    let markers = [];
    let map;
    let movingLatLng;
    let firstTimeLoad = true;
    let commentBoxCta;
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const lateArrivalStatuses = ['Arrival Time Exceeded', 'Driver Arrived', 'Patient Enroute'];
    const providers = [$scope.providerMapping.LYFT, $scope.providerMapping.UBER];
    const { transportationTypeConsts } = relaylib.vendorPortal;

    const refreshActiveRideTiles = () => {
      $rootScope.$broadcast('refreshActiveRideTiles');
    };

    const refreshIssuesTab = () => {
      $rootScope.$broadcast('refreshIssuesTab');
    };
    $scope.loggedInUser = userDetails;
    $scope.moment = moment;
    $scope.driverAlert = {
      ctas: {
        call_driver: false,
        call_patient: false,
      },
    };
    $scope.rideDetails = rideDetails;
    /** Condition For GH Ride Order share */
    $scope.isNotGHTRideShare = !!($scope.isGHTRide && !$scope.isMasRide && !providers.includes($scope.rideDetails.provider_id));
    $scope.isGHTRideShare = !!($scope.isGHTRide && !$scope.isMasRide && providers.includes($scope.rideDetails.provider_id));
    $scope.isOCCMRole = isOCCMRole() || permissionFilter($scope.permissionsConstants.MARKET_SEGMENT_READ);
    // Setting rideId in scope for later use in constructing presence channel name
    $scope.rideId = rideDetails.id;
    // Variables to manage active users parallely viewing this ride
    $scope.activeUsersOnThisAppointment = {};
    $scope.countOfActiveUsersOnThisAppointment = 0;
    let sendingDriverAlertCTAsToServer;
    $scope.showRideStatusDropdownForZtrip = rideDetails.isZtripProviderRide && [$scope.ride_status.CONFIRM_MEMBER_PICKUP.status, $scope.ride_status.FINDING_DRIVER.status, $scope.ride_status.DRIVER_CONFIRMED.status, $scope.ride_status.DRIVER_ARRIVED.status, $scope.ride_status.LATE_ARRIVAL.status, $scope.ride_status.ARRIVAL_TIME_EXCEEDED.status].includes(rideDetails.ride_status);
    $scope.showRideStatusDropdown =     ![$scope.providerMapping.UBER, $scope.providerMapping.LYFT].includes(rideDetails.provider_id)
     && !(
       ([$scope.ride_status.RIDE_COMPLETED.status, $scope.ride_status.PROVIDER_NO_SHOW.status, $scope.ride_status.PATIENT_NO_SHOW.status].includes(rideDetails.ride_status))
       && rideDetails.ride_category === 'active'
     )
     && !(
       ([$scope.ride_status.VARIANCE_ISSUE.status, $scope.ride_status.REQUEST_OVERDUE.status].includes(rideDetails.ride_status))
       && rideDetails.ride_category === 'issue'
     )
     && !rideDetails.isZtripProviderRide;
    $scope.showDispatchDriverButton =       ![$scope.providerMapping.UBER, $scope.providerMapping.LYFT].includes(rideDetails.provider_id)
       && ((
         ([$scope.ride_status.RIDE_COMPLETED.status, $scope.ride_status.PROVIDER_NO_SHOW.status, $scope.ride_status.PATIENT_NO_SHOW.status].includes(rideDetails.ride_status))
         && rideDetails.ride_category === 'active'
       )
        || (rideDetails.ride_status === $scope.ride_status.REQUEST_OVERDUE.status && rideDetails.ride_category === 'issue')
       );
    const rideCancel = async (selectedReason, flag) => {
      try {
        loadingScreenFactory.showLoadingScreen();
        const {
          data: {
            success, message,
          },
        } = await $http.post(`${API_BASE_URL}order/${$scope.rideDetails.appointment.external_order_id}/cancel`,
          {
            system_code: selectedReason,
            ride_id: $scope.rideDetails.id,
            cancel_all: flag,
          });
        if (!success) {
          toaster.pop({
            type: 'error',
            title: message || 'Unable to update status of provider',
            timeout: 3000,
          });
        } else {
          $rootScope.$broadcast('refreshActiveRideModal');
          $rootScope.$broadcast('refreshActiveRideTiles');
          $scope.closePopup();
        }
      } catch (error) {
        toaster.pop({
          type: 'error',
          title: (error && error.message) || 'Unable to update status of provider',
          timeout: 3000,
        });
      } finally {
        loadingScreenFactory.hideLoadingScreen();
      }
    };
    $scope.openModal = function (selectedReason) {
      const modalInstance =   ngDialog.open({
        ribedBy: 'modal-body',
        templateUrl: 'ngDialogTemplate1',
        className: 'ngdialog-theme-default',
      });
      modalInstance.closePromise.then((res) => {
        if (typeof (res.value) === 'boolean') {
          rideCancel(selectedReason, res.value);
        }
      });
    };
    $scope.rideStatusesList = [relaylib.ride.status.RIDE_CANCELED.status];
    $scope.updateStatus = (selectedAction) => {
      $scope.showReasonCodes = false;
      if (selectedAction) {
        $scope.showReasonCodes = true;
      }
    };
    const refreshPopupFromApi = (id) => {
      // id determines the ride id
      const rideId = id || $scope.rideDetails.id;
      const refreshPopupCall = $http.get(`${API_BASE_URL}ride/getRideDetailsById/${rideId}`, {
        params: {
          org_id: $scope.userDetails.organisation.id,
          checkIfZtripProviderRide: true,
        },
      });
      refreshPopupCall.then((result) => {
        if (result.data.success) {
          $scope.rideDetails = result.data.rideDetails;
          // eslint-disable-next-line no-use-before-define
          makeViewChanges();
        }
      });
    };

    const setDriverAlertCTAs = () => {
      if (!$scope.rideDetails.cta) {
        $scope.rideDetails.cta = {};
      }

      if (!$scope.rideDetails.cta.call_driver) {
        $scope.rideDetails.cta.call_driver = {
          by: '',
          at: '',
        };
      }
      if (!$scope.rideDetails.cta.call_patient) {
        $scope.rideDetails.cta.call_patient = {
          by: '',
          at: '',
        };
      }

      if (sendingDriverAlertCTAsToServer) {
        if (!$scope.rideDetails.cta.call_driver.by && $scope.driverAlert.ctas.call_driver) {
          $scope.rideDetails.cta.call_driver.byName = `${$scope.userDetails.first_name} ${$scope.userDetails.last_name}`;
          $scope.rideDetails.cta.call_driver.by = $scope.userDetails.username;
          $scope.rideDetails.cta.call_driver.at = new Date().getTime();
        }

        if (!$scope.rideDetails.cta.call_patient.by && $scope.driverAlert.ctas.call_patient) {
          $scope.rideDetails.cta.call_patient.byName = `${$scope.userDetails.first_name} ${$scope.userDetails.last_name}`;
          $scope.rideDetails.cta.call_patient.by = $scope.userDetails.username;
          $scope.rideDetails.cta.call_patient.at = new Date().getTime();
        }
      }
      if ($scope.rideDetails.cta.call_driver.at) {
        $scope.rideDetails.cta.call_driver.at = moment($scope.rideDetails.cta.call_driver.at).format('hh:mm a');
      }
      if ($scope.rideDetails.cta.call_patient.at) {
        $scope.rideDetails.cta.call_patient.at = moment($scope.rideDetails.cta.call_patient.at).format('hh:mm a');
      }

      $scope.driverAlert.ctas.call_driver = !!$scope.rideDetails.cta.call_driver.by;
      $scope.driverAlert.ctas.call_patient = !!$scope.rideDetails.cta.call_patient.by;
    };

    function openNotesPopup(modalData) {
      const notesModal = $uibModal.open({
        animation: true,
        template: require('../views/notes.html'),
        controller: 'notesCtrl',
        controllerAs: '$notesCtrl',
        size: 'md',
        backdrop: 'static',
        windowClass: 'bookAnotherZindex',
        resolve: {
          data() {
            return modalData;
          },
        },
      });
      return new Promise((resolve, reject) => {
        notesModal.result.then(
          (notes) => {
            resolve(notes);
          },
          () => {
            reject();
          },
        );
      });
    }

    const bookAnotherRideMas = async function bookAnotherRideMas() {
      const notesModalData = {
        cta: 'Book Another Ride',
        heading: 'Book Another Ride',
        confirmationLine: 'Are you sure you want to Book Another Ride ?',
      };
      let notes;
      try {
        notes = (await openNotesPopup(notesModalData)) || '';
      } catch (err) {
        return;
      }
      try {
        const res = await $http.patch(`${API_BASE_URL}rides/${$scope.rideDetails.id}`, { op: 'bookAnother', comments: notes });
        if (!(res.data || {}).success) {
          toaster.pop({
            type: 'error',
            title: res.message,
            showCloseButton: true,
            timeout: 10000,
          });
          return;
        }
        SweetAlert.swal({
          title: 'Done',
          text: 'Ride Booked Successfully',
          type: 'success',
        });
        refreshIssuesTab();
        refreshActiveRideTiles();
        $scope.closePopup();
      } catch (err) {
        const message = err.data && err.data.message ? err.data.message : err.message;
        toaster.pop({
          type: 'error',
          title: message,
          showCloseButton: true,
          timeout: 10000,
        });
      } finally {
        $scope.$apply();
      }
    };
    const cancelRideReason = function cancelRideReason() {
      $scope.showReasonCodes = true;
    };
    const cancelAndBookRide = function cancelAndBookRide(buttonText) {
      const ctaUrl = `${API_BASE_URL}ride/update/${$scope.rideDetails.id}`;
      const params = {
        ride_status: 'Ride Canceled',
        dontupdatedate: true,
        ctaType: buttonText,
      };
      if ($scope.rideDetails.variance_type) {
        params.variance_type = $scope.rideDetails.variance_type;
        params.show_in_variance_tab = false;
      }

      if ($scope.isMasRide || $scope.isGHTRideShare) {
        bookAnotherRideMas();
        return;
      }

      const cancelAndBookRideCall = $http.put(ctaUrl, params);
      cancelAndBookRideCall.then(
        (result) => {
          if (result.data.success) {
            SweetAlert.swal(
              {
                title: 'Ride Canceled!',
                text: 'Ride Canceled Successfully',
                type: 'success',
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'OK',
                closeOnConfirm: true,
              },
              () => {
                $state.go('main.dashboard.createAppointment', {
                  bookAnotherId: $scope.rideDetails.id,
                  caller,
                });
              },
            );
            $scope.closePopup();
          }
        },
        (err) => {
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };
    const cancelRide = function cancelRide(buttonText, comments) {
      const ctaUrl = `${API_BASE_URL}ride/cancel`;

      const params = {
        ride_id: $scope.rideDetails.id,
        ctaType: buttonText,
      };

      if (comments) {
        params.comments = $scope.rideDetails.comments;
      }

      const cancelRideCall = $http.put(ctaUrl, params);
      cancelRideCall.then(
        (result) => {
          if (result.data.success) {
            SweetAlert.swal({
              title: 'Ride Cancelled!',
              text: 'Ride Cancelled Successfully',
              type: 'success',
            });
            refreshIssuesTab();
            refreshActiveRideTiles();
            $scope.closePopup();
          }
        },
        (err) => {
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    const editRiderDetails = () => {
      $scope.closePopup();

      const redirectState = $scope.isMasRide ? 'main.dashboard.masOrderDetails' : 'main.dashboard.createAppointment';
      $state.go(redirectState, {
        rideId: $scope.rideDetails.id,
        caller,
      });
    };

    const bookAnotherRide = function bookAnotherRide() {
      if ($scope.isMasRide || $scope.isGHTRideShare) {
        bookAnotherRideMas();
        return;
      }
      $scope.closePopup();
      const params = {
        bookAnotherId: $scope.rideDetails.id,
        caller,
      };

      if ($scope.rideDetails.ride_status === $scope.ride_status.VARIANCE_ISSUE.status && $scope.isMasRide) {
        params.variance_type = 1;
      } else if ($scope.rideDetails.variance_type) {
        params.variance_type = $scope.rideDetails.variance_type;
      }
      $state.go('main.dashboard.createAppointment', params);
    };

    const cancelLeg = async () => {
      const ctaUrl = `${API_BASE_URL}ride/update/${$scope.rideDetails.id}`;
      const params = {
        comments: $scope.rideDetails.comments,
        ride_status: $scope.ride_status.RIDE_CANCELED.status,
        ride_category: $scope.ride_status.RIDE_CANCELED.type,
        dontupdatedate: true,
        issue_cta: true,
      };

      try {
        await $http.put(ctaUrl, params);
        SweetAlert.swal({
          title: 'Issue Addressed!',
          text: 'Issue Addressed Successfully',
          type: 'success',
          issue_cta: true,
        });
        refreshIssuesTab();
        refreshActiveRideTiles();
        $scope.closePopup();
      } catch (err) {
        toaster.pop({
          type: 'error',
          title: (err.data && err.data.message) || err.message,
          showCloseButton: true,
          timeout: 10000,
        });
      } finally {
        $scope.$apply();
      }
    };

    const clearAlert = (buttonText) => {
      const ctaUrl = `${API_BASE_URL}ride/update/${$scope.rideDetails.id}`;
      const params = {
        comments: $scope.rideDetails.comments,
        ride_category: 'completed',
        manually_resolved: true,
        action: 'Alert Cleared',
        dontupdatedate: true,
        issue_cta: true, // Send extra flag to denote that this action will clear an issue
        ctaType: buttonText,
      };
      if ($scope.isGHTRideShare && (($scope.rideDetails.leg_type === 'round' && $scope.rideDetails.ride_type !== 'return') || ($scope.rideDetails.leg_type === 'multi'
          && $scope.rideDetails.leg_no !== $scope.rideDetails.appointment.ride_details.length))
         && ($scope.rideDetails.ride_status === 'Driver Canceled' || $scope.rideDetails.ride_status === 'Patient No Show')) {
        params.ride_category = 'active';
        if ($scope.rideDetails.ride_status === 'Driver Canceled') params.ride_status = 'Provider No Show';
      } else if ($scope.isGHTRideShare && $scope.rideDetails.ride_status === 'Driver Canceled') {
        // Update Ride Status to Provider No Show. In case it is GHRideShare Single Leg Ride
        params.ride_status = 'Provider No Show';
      }

      if ($scope.rideDetails.variance_type) {
        params.variance_type = $scope.rideDetails.variance_type;
        params.show_in_variance_tab = false;
      }

      const clearAlertCall = $http.put(ctaUrl, params);
      clearAlertCall.then(
        (result) => {
          if (result.data.success) {
            SweetAlert.swal({
              title: 'Issue Addressed!',
              text: 'Issue Addressed Successfully',
              type: 'success',
            });
            refreshIssuesTab();
            refreshActiveRideTiles();
            $scope.closePopup();
          }
        },
        (err) => {
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    const informFacility = function informFacility(buttonText) {
      const ctaUrl = `${API_BASE_URL}ride/update/${$scope.rideDetails.id}`;

      const params = {
        comments: $scope.rideDetails.comments,
        ride_category: 'active',
        issue_cta: true, // Send extra flag to denote that this action will clear an issue
        ctaType: buttonText,
      };

      const informFacilityCall = $http.put(ctaUrl, params);
      informFacilityCall.then(
        (result) => {
          if (result.data.success) {
            $scope.cancelConfirm();
            commentBoxCta.show = false;
            refreshPopupFromApi();
            refreshIssuesTab();
            refreshActiveRideTiles();
            SweetAlert.swal({
              title: `${$scope.isMasRide || $scope.isGHTRideShare ? 'Passenger' : 'Destination'} Informed!`,
              text: `${$scope.isMasRide || $scope.isGHTRideShare ? 'Passenger' : 'Destination'} Informed Successfully`,
              type: 'success',
            });
          }
        },
        (err) => {
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    const approveSurgePricing = (buttonText) => {
      const ctaUrl = `${API_BASE_URL}ride/update/${$scope.rideDetails.id}`;
      const params = {
        higher_price_confirmed: true,
        ride_category: 'active',
        ride_status: 'Surge Approved',
        action: 'Surge Approved',
        issue_cta: true, // Send extra flag to denote that this action will clear an issue
        ctaType: buttonText,
      };
      const approveSurgePricingCall = $http.put(ctaUrl, params);
      approveSurgePricingCall.then(
        (result) => {
          if (result.data.success) {
            SweetAlert.swal({
              title: 'Surge Appoved!',
              text: 'Surge Approved Successfully',
              type: 'success',
            });
            $scope.closePopup();
            refreshIssuesTab();
          }
        },
        (err) => {
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    const noReturnTripNeeded = (buttonText) => {
      const ctaUrl = `${API_BASE_URL}ride/update/${$scope.rideDetails.id}`;
      const params = {
        ride_category: 'completed',
        action: 'Return trip canceled',
        dontupdatedate: true,
        ctaType: buttonText,
      };
      const noReturnTripNeededCall = $http.put(ctaUrl, params);
      noReturnTripNeededCall.then(
        (result) => {
          if (result.data.success) {
            SweetAlert.swal({
              title: 'Trip Completed!',
              text: 'Trip Completed Successfully',
              type: 'success',
            });
            refreshActiveRideTiles();
            $scope.closePopup();
          }
        },
        (err) => {
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    const bookNextTrip = (buttonText) => {
      const ctaUrl = `${API_BASE_URL}rides/bookNextRide`;
      const params = {
        ride_id: $scope.rideDetails.id,
        action: 'Next trip booked',
        book_next_trip: true,
        ctaType: buttonText,
      };
      const bookReturnTripCall = $http.put(ctaUrl, params);
      bookReturnTripCall.then(
        (result) => {
          if (result.data.success) {
            SweetAlert.swal({
              title: 'Next Ride Booked!',
              text: 'Next Ride Booked Successfully',
              type: 'success',
            });
            refreshPopupFromApi(result.data.ride_id);
            refreshActiveRideTiles();
          }
        },
        (err) => {
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    const clearRideAction = (buttonText) => {
      $scope.clearRideDisabled = true;
      const ctaUrl = `${API_BASE_URL}ride/clear_from_view`;
      const params = {
        ride_id: $scope.rideDetails.id,
        ctaType: buttonText,
      };
      if (($scope.isMasRide || $scope.isGHTRideShare) && $scope.rideDetails.ride_status === $scope.ride_status.NO_DRIVER_AVAILABLE.status) {
        params.snooze = true;
        params.comments = $scope.rideDetails.comments;
      }
      const bookReturnTripCall = $http.put(ctaUrl, params);
      bookReturnTripCall.then(
        (result) => {
          $scope.clearRideDisabled = false;
          if (result.data.success) {
            SweetAlert.swal({
              title: 'Ride Cleared!',
              text: 'Ride Cleared Successfully',
              type: 'success',
            });
            $scope.closePopup();
            refreshActiveRideTiles();
            refreshIssuesTab();
          } else {
            toaster.pop({
              type: 'error',
              title: 'Not able to clear ride',
              showCloseButton: true,
              timeout: 10000,
            });
          }
        },
        (err) => {
          $scope.clearRideDisabled = false;
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    const bookReturnTrip = (buttonText) => {
      const ctaUrl = `${API_BASE_URL}rides/bookNextRide`;
      const params = {
        ride_id: $scope.rideDetails.id,
        book_return_trip: true,
        ctaType: buttonText,
      };
      const bookReturnTripCall = $http.put(ctaUrl, params);
      bookReturnTripCall.then(
        (result) => {
          if (result.data.success) {
            SweetAlert.swal({
              title: 'Return Trip Booked!',
              text: 'Return Trip Booked Successfully',
              type: 'success',
            });
            refreshPopupFromApi(result.data.ride_id);
            refreshActiveRideTiles();
          }
        },
        (err) => {
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    function chargeCard() {
      const ctaUrl = `${API_BASE_URL}rechargeCreditCard/${$scope.rideDetails.id}`;

      const chargeCardCall = $http.put(ctaUrl);
      loadingScreenFactory.showLoadingScreen();
      chargeCardCall.then(
        (result) => {
          if (result.data.success) {
            SweetAlert.swal({
              title: 'Card Charged!',
              text: 'Card Charged Successfully',
              type: 'success',
            });
            refreshIssuesTab();
            refreshActiveRideTiles();
            $scope.closePopup();
          }
          loadingScreenFactory.hideLoadingScreen();
        },
        (err) => {
          loadingScreenFactory.hideLoadingScreen();
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    }

    const keepAppointment = (buttonText) => {
      const ctaUrl = `${API_BASE_URL}ride/update/${$scope.rideDetails.id}`;
      const varianceType = $scope.rideDetails.variance_type;
      const params = {
        ride_status: 'Ride Completed',
        ride_category: 'active',
        action: 'Appointment kept',
        issue_cta: true, // Send extra flag to denote that this action will clear an issue
        variance_type: varianceType,
        ctaType: buttonText,

      };
      // RA-19975
      if ($scope.rideDetails.leg_type === 'round' || $scope.rideDetails.leg_type === 'multi') {
        params.ride_cleared = false; // this will ensure that the next leg starts appearing on client dashboard
      }
      if (
        ($scope.isMasRide || $scope.isGHTRideShare)
        && ($scope.rideDetails.leg_type === 'single'
          || ($scope.rideDetails.leg_type === 'round' && $scope.rideDetails.ride_type === 'return')
          || ($scope.rideDetails.leg_type === 'multi' && $scope.rideDetails.leg_no === $scope.rideDetails.appointment.ride_details.length))
      ) {
        params.ride_category = 'completed';
      }
      if ($scope.rideDetails.comments) {
        params.comments = $scope.rideDetails.comments;
      }
      const keepAppointmentCall = $http.put(ctaUrl, params);
      keepAppointmentCall.then(
        () => {
          refreshPopupFromApi();
          refreshActiveRideTiles();
          SweetAlert.swal({
            title: 'Updated',
            text: 'Ride status updated successfully',
            type: 'success',
            confirmButtonText: 'Ok',
            closeOnConfirm: true,
            confirmButtonColor: '#DD6B55',
          });
          $scope.cancelConfirm();
        },
        (err) => {
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    const cancelRideWithComments = function cancelRideWithComments(buttonText) {
      cancelRide(buttonText, true); // set comments to true in late arrival
    };

    const resolveVariance = async (buttonText) => {
      try {
        let ctaUrl;
        const params = {
          action: 'Variance Resolved',
          issue_cta: true, // Send extra flag to denote that this action will clear an issue
          ctaType: buttonText,
        };
        let resolveVarianceResult;
        if ($scope.rideDetails.variance_type) {
          Object.assign(params, {
            variance_type: $scope.rideDetails.variance_type,
            show_in_variance_tab: false,
          });
        }
        loadingScreenFactory.showLoadingScreen();
        if (!providers.includes($scope.rideDetails.provider_id)) {
          // Check if the provider is lyft or uber
          ctaUrl = `${API_BASE_URL}order/${$scope.rideDetails.appointment.external_order_id}/assignment/status`;
          Object.assign(params, {
            statusText: $scope.ride_status.RIDE_COMPLETED.status,
            status: '1', // Ride Completed Status Text
            ride_id: $scope.rideDetails.id,
          });
          resolveVarianceResult = await $http.post(ctaUrl, params);
        } else {
          ctaUrl = `${API_BASE_URL}ride/update/${$scope.rideDetails.id}`; // for normal Ride
          Object.assign(params, {
            comments: $scope.rideDetails.comments,
            ride_category: 'completed',
            manually_resolved: true,
            ride_status: $scope.ride_status.RIDE_COMPLETED.status,
          });
          resolveVarianceResult = await $http.put(ctaUrl, params);
        }
        if (resolveVarianceResult.data.success) {
          SweetAlert.swal({
            title: 'Issue Addressed!',
            text: 'Issue Addressed Successfully',
            type: 'success',
          });
          refreshIssuesTab();
          refreshActiveRideTiles();
          $scope.closePopup();
        }
      } catch (e) {
        toaster.pop({
          type: 'error',
          title: e.data.message,
          showCloseButton: true,
          timeout: 10000,
        });
      } finally {
        loadingScreenFactory.hideLoadingScreen();
      }
    };
    const getSystemSettings = async () => {
      try {
        loadingScreenFactory.showLoadingScreen();
        const data = await $http.get(`${API_BASE_URL}setting/default?setting_name=traditional_ride_cancellation`);
        return data.data.settings.traditional_ride_cancellation;
      } catch (error) {
        toaster.pop({
          type: 'error',
          title: (error && error.message) || 'Unable to get system settings',
          timeout: 3000,
        });
        return false;
      } finally {
        loadingScreenFactory.hideLoadingScreen();
      }
    };
    $scope.traditionalRideCancellation = await getSystemSettings();

    const resolveVarianceFunction = (buttonText) => {
      SweetAlert.swal(
        {
          title: 'Info',
          text: 'Please make the necessary updates of subsequent legs in the Intake system',
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          closeOnConfirm: true,
          confirmButtonColor: '#DD6B55',
          cancelButtonText: 'No',
        },
        () => {
          resolveVariance(buttonText);
        },
      );
    };
    if (!permissionFilter($scope.permissionsConstants.DISABLE_CTAS)) {
      (async function () {
        try {
          loadingScreenFactory.showLoadingScreen();
          const cancelReasonData = await $http.get(
            `${API_BASE_URL}cancellationcodes`,
          );
          $scope.cancelReasonCodes = cancelReasonData.data.data;
        } catch (error) {
          toaster.pop({
            type: 'error',
            title: (error && error.message) || 'Unable to get no show codes',
            timeout: 3000,
          });
        } finally {
          loadingScreenFactory.hideLoadingScreen();
        }
      }());
    }
    async function setAncestorOrgFileNumberLabel(orgId) {
      try {
        const { data: { orgsWithInheritedSettings: [{ file_number_label: ancestorfileNumberLabel } = {}] = [] } } = await orgHierarchyFactory.getOrgsWithInheritedSettings(orgId,
          [
            'file_number_label',
          ]);
        if (ancestorfileNumberLabel) {
          $scope.fileNumberLabel = ancestorfileNumberLabel;
        }
      } catch (error) {
        toaster.pop({
          type: 'error',
          title: (error.data || {}).message ? error.data.message : error.message,
          showCloseButton: true,
          timeout: 10000,
        });
      }
    }

    const statusCta = {
      'Finding Driver': {
        cta: [
          {
            functionCall: cancelAndBookRide,
            buttonDisplayText: `Cancel and Book Another ${!$scope.isGHTRideShare ? 'Ride' : ''}`,
            type: 'action',
            show: true,
          },
          {
            functionCall: cancelRide,
            buttonDisplayText: 'Cancel Ride',
            type: 'action',
            show: !$scope.isGHTRideShare,
          },
          {
            functionCall: cancelRideReason,
            buttonDisplayText: 'Cancel',
            type: 'cancel',
            show: $scope.isGHTRideShare && $scope.traditionalRideCancellation,
          },
        ],
        type: 'info',
        canbeDriverAlert: true,
      },
      'Driver Confirmed': {
        cta: [
          {
            functionCall: cancelAndBookRide,
            buttonDisplayText: `Cancel and Book Another ${!$scope.isGHTRideShare ? 'Ride' : ''}`,
            type: 'action',
            show: true,
          },
          {
            functionCall: cancelRide,
            buttonDisplayText: 'Cancel Ride',
            type: 'action',
            show: !$scope.isGHTRideShare,
          },
          {
            functionCall: cancelRideReason,
            buttonDisplayText: 'Cancel',
            type: 'cancel',
            show: $scope.isGHTRideShare && $scope.traditionalRideCancellation,
          },
        ],
        type: 'info',
        canbeDriverAlert: true,
      },
      'Driver Reconfirmed': {
        cta: [
          {
            functionCall: cancelAndBookRide,
            buttonDisplayText: 'Cancel and Book Another Ride',
            type: 'action',
            show: true,
          },
          {
            functionCall: cancelRide,
            buttonDisplayText: 'Cancel Ride',
            type: 'action',
            show: true,
          },
        ],
        type: 'info',
        canbeDriverAlert: true,
      },
      'Driver Arrived': {
        cta: [
          {
            functionCall: cancelAndBookRide,
            buttonDisplayText: `Cancel and Book Another ${!$scope.isGHTRideShare ? 'Ride' : ''}`,
            type: 'action',
            show: true,
          },
          {
            functionCall: cancelRide,
            buttonDisplayText: 'Cancel Ride',
            type: 'action',
            show: !$scope.isGHTRideShare,
          },
          {
            functionCall: cancelRideReason,
            buttonDisplayText: 'Cancel',
            type: 'cancel',
            show: $scope.isGHTRideShare && $scope.traditionalRideCancellation,
          },
        ],
        type: 'warn',
        canbeDriverAlert: true,
      },
      'Patient Enroute': {
        cta: [
          {
            functionCall: editRiderDetails,
            buttonDisplayText: 'Edit Rider Details',
            type: 'action',
            show: $scope.oldDashboard && !$scope.isMasRide && !$scope.isGHTRideShare,
          },
        ],
        type: 'info',
        canbeDriverAlert: true,
      },
      'Driver Canceled': {
        cta: [
          {
            functionCall: bookAnotherRide,
            buttonDisplayText: `Book Another ${!$scope.isGHTRideShare ? 'Ride' : ''}`,
            type: 'action',
            show: true,
          },
          {
            functionCall: clearAlert,
            buttonDisplayText: 'Clear Alert',
            commentButtonText: 'Confirm Clear Alert',
            type: 'comment',
            show: !$scope.isMasRide,
          },
          {
            functionCall: cancelLeg,
            buttonDisplayText: 'Cancel Leg',
            commentButtonText: 'Confirm Cancel Leg',
            type: 'comment',
            show: $scope.isMasRide,
          },
        ],
        type: 'danger',
      },
      'Patient No Show': {
        cta: [
          {
            functionCall: bookAnotherRide,
            buttonDisplayText: `Book Another ${!$scope.isGHTRideShare ? 'Ride' : ''}`,
            type: 'action',
            show: true,
          },
          {
            functionCall: clearAlert,
            buttonDisplayText: 'Clear Alert',
            commentButtonText: 'Confirm Clear Alert',
            type: 'comment',
            show: !$scope.isMasRide && !$scope.isNotGHTRideShare,
          },
          {
            functionCall: cancelLeg,
            buttonDisplayText: 'Cancel Leg',
            commentButtonText: 'Confirm Cancel Leg',
            type: 'comment',
            show: $scope.isMasRide,
          },
        ],
        type: 'danger',
      },
      'Late Arrival': {
        cta: [
          {
            functionCall: informFacility,
            buttonDisplayText: $scope.isMasRide ? 'Inform Passenger' : 'Inform Destination',
            commentButtonText: 'Confirm Notification',
            type: 'comment',
            show: $scope.oldDashboard && $scope.rideDetails.ride_category !== 'active',
          },
          {
            functionCall: cancelRideReason,
            buttonDisplayText: 'Cancel',
            type: 'cancel',
            show: $scope.isGHTRideShare && $scope.traditionalRideCancellation,
          },
        ],
        type: 'warn',
        canbeDriverAlert: false,
      },
      'Surge Approval Needed': {
        cta: [
          {
            functionCall: approveSurgePricing,
            buttonDisplayText: 'Approve Surge Pricing',
            type: 'surge',
            show: true,
          },
          {
            functionCall: cancelRide,
            buttonDisplayText: 'Cancel Ride',
            type: 'action',
            show: true,
          },
        ],
        type: 'warn',
      },
      'Ride Completed': {
        cta: [],
        type: 'success',
        canbeDriverAlert: false,
      },
      Round: {
        cta: [
          {
            functionCall: bookReturnTrip,
            buttonDisplayText: `Book ${!$scope.isGHTRideShare ? 'Return Trip' : 'Next Ride'}`,
            type: 'action',
            show: $scope.rideDetails.ride_category !== 'completed',
          },
          {
            functionCall: noReturnTripNeeded,
            buttonDisplayText: 'No Return Trip Needed',
            type: 'action',
            show: !$scope.isGHTRideShare && $scope.rideDetails.ride_category !== 'completed',
          },
        ],
        type: 'info',
      },
      Multi: {
        cta: [
          {
            functionCall: bookNextTrip,
            buttonDisplayText: 'Book Next Ride',
            type: 'action',
            show: $scope.rideDetails.ride_category !== 'completed',
          },
          {
            functionCall: noReturnTripNeeded,
            buttonDisplayText: 'No Ride Needed',
            type: 'action',
            show: !$scope.isGHTRideShare && $scope.rideDetails.ride_category !== 'completed',
          },
        ],
        type: 'info',
      },
      'Missed Surge Approval': {
        cta: [
          {
            functionCall: bookAnotherRide,
            buttonDisplayText: 'Book Another Ride',
            type: 'action',
            show: true,
          },
          {
            functionCall: clearAlert,
            buttonDisplayText: 'Clear Alert',
            commentButtonText: 'Confirm Clear Alert',
            type: 'comment',
            show: !$scope.isMasRide,
          },
          {
            functionCall: cancelLeg,
            buttonDisplayText: 'Cancel Leg',
            commentButtonText: 'Confirm Cancel Leg',
            type: 'comment',
            show: $scope.isMasRide,
          },
        ],
        type: 'danger',
      },
      'Ride Canceled': {
        cta: [
          {
            functionCall: bookAnotherRide,
            buttonDisplayText: 'Book Another Ride',
            type: 'action',
            show: true,
          },
          {
            functionCall: clearAlert,
            buttonDisplayText: 'Clear Alert',
            commentButtonText: 'Confirm Clear Alert',
            type: 'comment',
            show: !$scope.isMasRide,
          },
          {
            functionCall: cancelLeg,
            buttonDisplayText: 'Cancel Leg',
            commentButtonText: 'Confirm Cancel Leg',
            type: 'comment',
            show: $scope.isMasRide,
          },
        ],
        type: 'danger',
      },
      'No Driver Available': {
        cta: [
          {
            functionCall: bookAnotherRide,
            buttonDisplayText: 'Book Another Ride',
            type: 'action',
            show: $scope.oldDashboard,
          },
          {
            functionCall: clearAlert,
            buttonDisplayText: 'Clear Alert',
            commentButtonText: 'Confirm Clear Alert',
            type: 'comment',
            show: $scope.oldDashboard && !$scope.isMasRide && !$scope.isGHTRideShare,
          },
          {
            functionCall: clearRideAction,
            buttonDisplayText: ($scope.isMasRide || $scope.isGHTRideShare) ? 'Keep Trip' : 'Clear Ride',
            type: ($scope.isMasRide || $scope.isGHTRideShare) ? 'comment' : 'action',
            commentButtonText: ($scope.isMasRide || $scope.isGHTRideShare) ? 'Confirm Keep Trip' : undefined,
            show: !$scope.oldDashboard || $scope.isMasRide || $scope.isGHTRideShare,
          },
          {
            functionCall: cancelRideReason,
            buttonDisplayText: 'Cancel',
            type: 'cancel',
            show: $scope.isGHTRideShare && $scope.traditionalRideCancellation,
          },
        ],
        type: 'danger',
      },
      'Failed-Other': {
        cta: [
          {
            functionCall: bookAnotherRide,
            buttonDisplayText: `Book Another ${!$scope.isGHTRideShare ? 'Ride' : ''}`,
            type: 'action',
            show: true,
          },
          {
            functionCall: clearAlert,
            buttonDisplayText: 'Clear Alert',
            commentButtonText: 'Confirm Clear Alert',
            type: 'comment',
            show: !($scope.isMasRide || $scope.isGHTRideShare),
          },
          {
            functionCall: cancelLeg,
            buttonDisplayText: 'Cancel Leg',
            commentButtonText: 'Confirm Cancel Leg',
            type: 'comment',
            show: $scope.isMasRide,
          },
          {
            functionCall: cancelRideReason,
            buttonDisplayText: 'Cancel',
            type: 'cancel',
            show: $scope.isGHTRideShare && $scope.traditionalRideCancellation,
          },
        ],
        type: 'danger',
      },
      'Failed CC Auth': {
        cta: [
          {
            functionCall: bookAnotherRide,
            buttonDisplayText: 'Book Another Ride',
            type: 'action',
            show: $scope.oldDashboard,
          },
          {
            functionCall: clearAlert,
            buttonDisplayText: 'Clear Alert',
            commentButtonText: 'Confirm Clear Alert',
            type: 'comment',
            show: !(!$scope.oldDashboard || $scope.isMasRide),
          },
          {
            functionCall: clearRideAction,
            buttonDisplayText: 'Clear Ride',
            type: 'action',
            show: !$scope.oldDashboard,
          },
          {
            functionCall: cancelLeg,
            buttonDisplayText: 'Cancel Leg',
            commentButtonText: 'Confirm Cancel Leg',
            type: 'comment',
            show: $scope.isMasRide,
          },
        ],
        type: 'warn',
      },
      'Failed CC Payment': {
        cta: [
          {
            functionCall: chargeCard,
            buttonDisplayText: 'Charge Card',
            commentButtonText: 'Confirm Charge Card',
            type: 'action',
            show: true,
          },
          {
            functionCall: clearAlert,
            buttonDisplayText: 'Clear Alert',
            commentButtonText: 'Confirm Clear Alert',
            type: 'comment',
            show: !$scope.isMasRide,
          },
          {
            functionCall: cancelLeg,
            buttonDisplayText: 'Cancel Leg',
            commentButtonText: 'Confirm Cancel Leg',
            type: 'comment',
            show: $scope.isMasRide,
          },
        ],
        type: 'danger',
      },
      'Surge Approved': {
        cta: [
          {
            functionCall: cancelRide,
            buttonDisplayText: 'Cancel Ride',
            type: 'action',
            show: true,
          },
        ],
        type: 'warn',
      },
      'Variance Issue': {
        cta: [
          {
            functionCall: bookAnotherRide,
            buttonDisplayText: `Book Another ${!$scope.isGHTRideShare ? 'Ride' : ''}`,
            type: 'action',
            show: $scope.oldDashboard,
          },
          {
            functionCall: keepAppointment,
            buttonDisplayText: $scope.isMasRide ? 'Keep Leg' : 'Keep Trip',
            type: $scope.isMasRide ? 'comment' : 'action',
            commentButtonText: $scope.isMasRide ? 'Confirm Keep Leg' : undefined,
            show:
              $scope.oldDashboard
              && !$scope.isGHTRideShare
              && ($scope.isMasRide
                || !(
                  $scope.rideDetails.leg_type === 'single'
                  || ($scope.rideDetails.leg_type === 'round' && $scope.rideDetails.ride_type === 'return')
                  || ($scope.rideDetails.leg_type === 'multi' && $scope.rideDetails.leg_no === $scope.rideDetails.appointment.ride_details.length)
                )),
          },
          {
            functionCall: $scope.isMasRide ? cancelRideWithComments : cancelRide,
            buttonDisplayText: 'Cancel Leg',
            type: 'comment',
            commentButtonText: 'Confirm Cancel Leg',
            show: $scope.oldDashboard && $scope.isMasRide,
          },
          {
            functionCall: ($scope.isGHTRideShare) ? keepAppointment : resolveVariance,
            buttonDisplayText: 'Clear Alert',
            commentButtonText: 'Confirm Clear Alert',
            type: 'comment',
            show: ($scope.oldDashboard && !$scope.isMasRide && !$scope.isGHTRide) || $scope.isGHTRideShare,
          },
          {
            functionCall: clearRideAction,
            buttonDisplayText: 'Clear Ride',
            type: 'action',
            show: !$scope.oldDashboard && !$scope.isMasRide,
          },
          {
            functionCall: resolveVarianceFunction, // sweet Alert for resolving variance
            buttonDisplayText: 'Clear Alert',
            type: 'action',
            show: $scope.oldDashboard && !$scope.isMasRide && $scope.isGHTRide,
          },
        ],
        type: 'warn',
        canbeDriverAlert: false,
      },
      'Variance Under': {
        cta: [
          {
            functionCall: clearAlert,
            buttonDisplayText: 'Clear Alert',
            commentButtonText: 'Confirm Clear Alert',
            type: 'comment',
            show: !(!$scope.oldDashboard || $scope.isMasRide),
          },
          {
            functionCall: clearRideAction,
            buttonDisplayText: 'Clear Ride',
            type: 'action',
            show: !$scope.oldDashboard,
          },
          {
            functionCall: cancelLeg,
            buttonDisplayText: 'Cancel Leg',
            commentButtonText: 'Confirm Cancel Leg',
            type: 'comment',
            show: $scope.isMasRide,
          },
        ],
        type: 'warn',
        canbeDriverAlert: false,
      },
      'Variance Over': {
        cta: [
          {
            functionCall: clearAlert,
            buttonDisplayText: 'Clear Alert',
            commentButtonText: 'Confirm Clear Alert',
            type: 'comment',
            show: !(!$scope.oldDashboard || $scope.isMasRide),
          },
          {
            functionCall: clearRideAction,
            buttonDisplayText: 'Clear Ride',
            type: 'action',
            show: !$scope.oldDashboard,
          },

          {
            functionCall: cancelLeg,
            buttonDisplayText: 'Cancel Leg',
            commentButtonText: 'Confirm Cancel Leg',
            type: 'comment',
            show: $scope.isMasRide,
          },
        ],
        type: 'warn',
        canbeDriverAlert: false,
      },
      'Request Overdue': {
        type: 'danger',
        canbeDriverAlert: false,
      },
      'Arrival Time Exceeded': {
        cta: [
          {
            functionCall: informFacility,
            buttonDisplayText: ($scope.isMasRide  ||  $scope.isGHTRideShare) ? 'Inform Passenger' : 'Inform Destination',
            commentButtonText: 'Confirm Notification',
            type: 'comment',
            show: $scope.oldDashboard && $scope.rideDetails.ride_category !== 'active',
          },
          {
            functionCall: cancelRideWithComments,
            buttonDisplayText: 'Cancel Ride',
            commentButtonText: 'Cancel Ride',
            type: 'comment',
            show: !$scope.isGHTRideShare,
          },
          {
            functionCall: cancelRideReason,
            buttonDisplayText: 'Cancel',
            type: 'cancel',
            show: $scope.isGHTRideShare && $scope.traditionalRideCancellation,
          },
        ],
        type: 'warn',
      },
      'Confirm Member Pickup': {
        cta: [],
        type: 'danger',
      },
      'Confirm Member Dropoff': {
        cta: [],
        type: 'danger',
      },
      'Provider No Show': {
        cta: [
        ],
        type: 'danger',
      },
      'Pending Disposition': {
        cta: [],
        type: 'success',
      },
    };

    const modifyCTAsForVariance = () => {
      $scope.ctas = statusCta[$scope.rideDetails.ride_status].cta;
      if (!providers.includes($scope.rideDetails.provider_id)) {
        // cta should be clear alert only for Variance Issue in GH Rides
        for (let ctaIndex = 0; ctaIndex < $scope.ctas.length - 1; ctaIndex += 1) {
          $scope.ctas[ctaIndex].show = false;
        }
      } else {
        // If this is a normal ride, CTA for GH Ride must be disabled
        $scope.ctas[$scope.ctas.length - 1].show = false;
      }
    };

    if ($scope.rideDetails.appointment.organisation.customizable_file_number) {
      $scope.fileNumberLabel = $scope.rideDetails.appointment.organisation.file_number_label;
    } else {
      setAncestorOrgFileNumberLabel($scope.rideDetails.appointment.organisation.id);
    }

    $scope.sendDriverAlertCTAsToServer = (CTAs) => {
      if (sendingDriverAlertCTAsToServer) return;
      sendingDriverAlertCTAsToServer = true;
      const ctaUrl = `${API_BASE_URL}ride/update/${$scope.rideDetails.id}`;
      const buttonsToDisable = [];
      const updateCTAs = {};
      const CTAsArray = _.isArray(CTAs) ? CTAs : [CTAs];

      CTAsArray.forEach((cta) => {
        buttonsToDisable.push(window.jQuery(`#${cta}`));
        updateCTAs[cta] = {};
        updateCTAs[cta].byName = window.jQuery(`#${cta}`).prop('checked') ? `${$scope.userDetails.first_name} ${$scope.userDetails.last_name}` : '';
        $scope.rideDetails.cta[cta].byName = updateCTAs[cta].byName;
        updateCTAs[cta].by = window.jQuery(`#${cta}`).prop('checked') ? $scope.userDetails.username : '';
        $scope.rideDetails.cta[cta].by = updateCTAs[cta].by;
        $scope.rideDetails.cta[cta].at = moment().format('hh:mm a');
      });

      buttonsToDisable.forEach((b) => {
        b.prop('disabled', true);
      });

      const params = {
        action: 'CTA update',
        cta: updateCTAs,
        dontupdatedate: true,
      };

      const updateCTACall = $http.put(ctaUrl, params);
      updateCTACall.then(
        () => {
          buttonsToDisable.forEach((b) => {
            b.prop('disabled', false);
          });
          sendingDriverAlertCTAsToServer = false;
        },
        (err) => {
          buttonsToDisable.forEach((b) => {
            b.prop('disabled', false);
          });
          sendingDriverAlertCTAsToServer = false;
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    setDriverAlertCTAs();

    // Helper function to check and update list/count of users parallely active on a ride
    let checkAndUpdateCurrentlyViewingAdminsRunning = false;
    const checkAndUpdateCurrentlyViewingAdmins = () => {
      if (checkAndUpdateCurrentlyViewingAdminsRunning) {
        return; // Check to prevent parallel calling attempts to this function
      }
      checkAndUpdateCurrentlyViewingAdminsRunning = true;
      pubnubNotificationFactory.getHereNowOfChannel(`presence_${$scope.rideId}`, (status, response) => {
        const activeUsers = {};
        let activeUsersCount = 0;

        if (response && response.channels && response.channels[`presence_${$scope.rideId}`]) {
          const occupants = response.channels[`presence_${$scope.rideId}`].occupants ? response.channels[`presence_${$scope.rideId}`].occupants : [];
          occupants.forEach((o) => {
            if (o.state && typeof activeUsers[o.state.id] === 'undefined') {
              activeUsers[o.state.id] = o.state;
              activeUsersCount += 1;
            }
          });
        }
        checkAndUpdateCurrentlyViewingAdminsRunning = false; // Reset flag....so that next attempt to check active users can run successfully.

        $scope.$apply(() => {
          $scope.activeUsersOnThisAppointment = activeUsers;
          $scope.countOfActiveUsersOnThisAppointment = activeUsersCount;
        });
      });
    };

    // Presence Listener for handling presence events coming directly from Pubnub service
    const presenceListeners = {
      presence(p) {
        if (!(p.channel === `presence_${$scope.rideId}` && ['state-change', 'leave', 'timeout'].indexOf(p.action) >= 0)) {
          return;
        }
        setTimeout(() => {
          checkAndUpdateCurrentlyViewingAdmins();
        }, 1000); // Put some delay before fetching here now details...
      },
      message(p) {
        if (p.channel !== `presence_${$scope.rideId}`) {
          return; // Skip all messages who do not belongs to our presence channel
        }

        const payload = p.message;

        toaster.pop({
          type: 'info',
          title: payload.message,
          showCloseButton: true,
          timeout: 10000,
        });
      },
    };

    // pubnubNotificationFactory.subscribeChannel("appt" + $scope.rideDetails.appointment.id);
    pubnubNotificationFactory.subscribeChannel(`appt_track${$scope.rideDetails.appointment.id}`);

    // Subscribing to current ride's presence channel
    pubnubNotificationFactory.subscribePresenceChannel(`presence_${$scope.rideId}`, {
      name: `${$scope.userDetails.first_name} ${$scope.userDetails.last_name}`,
      id: $scope.userDetails.user_id,
    });

    // pubnubNotificationFactory.subscribeChannelGroup("340apptgrp35485")

    if (
      $scope.rideDetails.ride_status === 'Driver Canceled'
      || $scope.rideDetails.ride_status === 'Patient No show'
      || $scope.rideDetails.ride_status === 'Ride Canceled'
    ) {
      $scope.rideDetails.driver_eta = null;
    }

    checkAndClearETA($scope.rideDetails);

    const statusColor = {
      info: '#23c6c8',
      plain: '#e7eaec',
      danger: '#ed5565',
      warn: '#F9A825',
      success: '#1c84c6',
    };

    $scope.getStyle = () => {
      if ($scope.isGHTRideShare && ([statuses.PATIENT_NO_SHOW.status, statuses.PROVIDER_NO_SHOW.status].includes($scope.rideDetails.ride_status)) && ($scope.rideDetails.leg_type === 'round' || $scope.rideDetails.leg_type === 'multi')) {
        $scope.rideDetails.displayStatus = rideStatusMapping($scope.rideDetails.ride_status, $scope.rideDetails.ride_category);
        $scope.rideDetails.statusType = $scope.rideDetails.displayStatus === statuses.PENDING_RIDE_REQUEST.status ? 'success' : statusCta[$scope.rideDetails.ride_status].type;
      }
      const color = $scope.rideDetails.statusType === 'plain' ? 'black' : 'white';
      const style = { color, 'font-weight': 'bold', 'background-color': statusColor[$scope.rideDetails.statusType] };
      return style;
    };

    $scope.closePopup = () => {
      pubnubNotificationFactory.unsubscribeChannel(`appt_track${$scope.rideDetails.appointment.id}`);
      // Unsubscribing presence channel for current ride
      pubnubNotificationFactory.unsubscribeChannel(`presence_${$scope.rideId}`);
      Pubnub.removeListener(presenceListeners);
      $uibModalInstance.dismiss(false);
    };

    $scope.$on('$destroy', () => {
      $scope.closePopup();
    });

    function setMapOnAll(_map) {
      for (let i = 0; i < markers.length; i += 1) {
        markers[i].setMap(_map);
      }
    }

    function deleteMarkers() {
      setMapOnAll(null);
      markers = [];
    }

    const setMapPoints = () => {
      //  NgMap.getMap({ id: 'dialogMap' }).then(function(map) {
      deleteMarkers();
      const sourcelatLong = new google.maps.LatLng($scope.rideDetails.source_lat_long[0], $scope.rideDetails.source_lat_long[1]);
      markers.push(
        new google.maps.Marker({
          position: sourcelatLong,
          map,
          label: 'S',
          icon: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
        }),
      );
      const destLatLong = new google.maps.LatLng($scope.rideDetails.dest_lat_long[0], $scope.rideDetails.dest_lat_long[1]);
      markers.push(
        new google.maps.Marker({
          position: destLatLong,
          map,
          label: 'D',
          // icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
        }),
      );
      google.maps.event.trigger(map, 'resize');
      if (!movingLatLng) {
        map.setCenter(sourcelatLong);
      }
      map.setZoom(13);

      if ($scope.rideDetails.ride_status === 'Variance Issue' && $scope.rideDetails.route_lat_long) {
        const routeCoordinates = $scope.rideDetails.route_lat_long;
        const routePath = new google.maps.Polyline({
          path: routeCoordinates,
          geodesic: true,
          strokeColor: '#FF0000',
          strokeOpacity: 1.0,
          strokeWeight: 2,
        });
        routePath.setMap(map);
      }
      //  });
    };
    $timeout(() => {
      map = new google.maps.Map(document.getElementById('dialogMap'), {
        zoom: 12,
        disableDefaultUI: true,
        scrollwheel: true,
        disableDoubleClickZoom: false,
        streetViewControl: false,
        zoomControl: true,
      });
      setMapPoints();
    }, 1000);

    let scale = 1;
    let fillOpacity = 1;
    const fillColor = $scope.rideDetails.car_color_code ? $scope.rideDetails.car_color_code : '#000';

    // eslint-disable-next-line max-len
    const path = 'M343.8,271.88a34.45,34.45,0,0,0,1.55,9.84l2.49,5.33,59.59-13.17L407.9,463.8c0,3.71,0,7.44-.05,11.18q-0.09,11.21-.36,22.59c-0.28,11.1-.68,22.32-1.19,33.58L406.2,533c-1,22.72-2.47,45.67-4,68.53-2.13,30.93-4.49,61.67-6.43,91.5-1.43,22.11-2.62,43.73-3.32,64.49-0.48,14.26-.76,28.1-0.67,41.47,0,6.57.15,13,.36,19.36s0.59,12.75,1.09,19.26c0.25,3.25.51,6.51,0.83,9.8,0.94,9.84,2.19,19.85,3.63,29.82h0c1,6.65,2,13.27,3.16,19.88s2.32,13.2,3.58,19.69,2.6,12.89,3.94,19.17h0c0.67,3.14,1.33,6.19,2,9.27,2.06,9.22,4.17,18.16,6.27,26.63h0q2.1,8.48,4.15,16.31c2.73,10.45,5.36,20,7.72,28.2,3.54,12.36,6.51,21.89,8.29,27.54,1.19,3.76,1.87,5.8,1.87,5.8l6.13,21a12,12,0,0,0,2.18,4,17.14,17.14,0,0,0,1.14,1.28,30,30,0,0,0,6.37,4.8h0c1.3,0.76,2.72,1.56,4.25,2.28h0c1.53,0.73,3.17,1.45,4.92,2.14h0c14.11,5.58,35,10.07,60.06,13.6h0l1.19,0.14c5.52,0.77,11.27,1.51,17.15,2.19,0.4,0,.79.1,1.19,0.14,6.7,0.76,13.6,1.44,20.68,2.09h0c3.53,0.33,7.12.65,10.73,1h0c3.61,0.3,7.21.58,10.88,0.86h0c7.36,0.54,14.83,1,22.39,1.47h0c22.69,1.33,46.08,2.22,68.92,2.71h0c15.24,0.33,30.2.48,44.62,0.48h9.74c14.41,0,29.38-.15,44.61-0.48h0c22.84-.49,46.23-1.38,68.92-2.71h0c7.55-.44,15-0.93,22.39-1.47h0c3.67-.27,7.28-0.56,10.88-0.86h0c3.6-.3,7.2-0.63,10.73-1h0c7.07-.65,14-1.33,20.68-2.09,0.4,0,.79-0.1,1.19-0.14,5.88-.68,11.63-1.42,17.15-2.19l1.19-.14h0c25-3.53,46-8,60.06-13.6h0c1.75-.69,3.39-1.41,4.92-2.14h0c1.53-.73,3-1.52,4.25-2.28h0a30,30,0,0,0,6.37-4.8,17.13,17.13,0,0,0,1.14-1.28,12,12,0,0,0,2.18-4l6.27-20.86s0.68-2,1.87-5.8c1.78-5.65,4.75-15.17,8.29-27.54,2.36-8.24,5-17.76,7.72-28.2q2-7.83,4.15-16.31h0c2.1-8.47,4.21-17.41,6.27-26.63,0.69-3.08,1.35-6.13,2-9.27h0c1.34-6.27,2.68-12.69,3.94-19.17s2.45-13.08,3.58-19.69,2.2-13.22,3.16-19.88h0c1.44-10,2.68-20,3.63-29.82,0.31-3.29.58-6.54,0.83-9.8,0.5-6.51.88-12.94,1.09-19.26s0.32-12.79.36-19.36c0.08-13.37-.19-27.21-0.67-41.47-0.7-20.76-1.88-42.38-3.32-64.49-1.94-29.83-4.3-60.57-6.43-91.5-1.57-22.86-3-45.81-4-68.53l-0.1-1.81c-0.51-11.25-.91-22.48-1.19-33.58q-0.28-11.37-.36-22.59c0-3.74-.06-7.47,0-11.18L1046.28,274,1105.8,287l2.49-5.33a34.45,34.45,0,0,0,1.55-9.84,19.76,19.76,0,0,0-.41-4.09c-0.1-.47-0.23-0.95-0.36-1.43s-0.26-1-.41-1.43a25.86,25.86,0,0,0-1.14-2.85,21.48,21.48,0,0,0-5.49-7.28h0a14,14,0,0,0-3.78-2.24l-51.92-18.5,0.41-167.31c0.62-1.14,1.24-2.25,1.81-3.38a135.75,135.75,0,0,0,6-13.46c0.85-2.23,1.62-4.44,2.33-6.66a144.59,144.59,0,0,0,5.39-23.35c0.66-4.48,1.15-9,1.5-13.6,0.18-2.29.3-4.62,0.41-6.94,0.23-4.65.35-9.34,0.41-14.17,0.12-9.66,0-19.75,0-30.44a384,384,0,0,0-2.59-45.32q-1-8.64-2.44-16.93a298,298,0,0,0-7.25-31.82c-0.73-2.54-1.49-5.08-2.28-7.56-2.37-7.46-5-14.63-7.93-21.59-1-2.32-1.92-4.63-3-6.9q-3.09-6.8-6.53-13.27c-1.14-2.16-2.32-4.32-3.52-6.42-2.4-4.21-4.94-8.32-7.57-12.32-1.31-2-2.68-4-4-5.9A227.4,227.4,0,0,0,995-240.53a234.92,234.92,0,0,0-20.68-19h0c-1.81-1.48-3.63-2.95-5.49-4.38h0c-1.86-1.43-3.74-2.85-5.65-4.23h0q-8.59-6.23-17.77-11.79h0c-2-1.23-4.09-2.48-6.17-3.66h0c-6.26-3.56-12.69-7-19.33-10.08h0c-2.2-1-4.44-2.05-6.68-3h0c-2.24-1-4.51-2-6.79-2.95h0c-4.58-1.9-9.21-3.71-13.94-5.42h0c-2.36-.85-4.75-1.67-7.15-2.47h0c-2.4-.81-4.82-1.62-7.25-2.38s-4.89-1.52-7.36-2.24h0c-2.47-.72-5-1.42-7.46-2.09h0q-3.75-1-7.57-1.95c-3.82-.95,0,0,0,0-7.64-1.88-15.43-3.6-23.37-5.09h0c-2.64-.49-5.31-0.93-8-1.38h0a514.11,514.11,0,0,0-58.4-6.33h0c-2.87-.15-5.76-0.27-8.65-0.38h0c-5.8-.22-11.62-0.38-17.51-0.43H714.68c-5.9.05-11.72,0.21-17.51,0.43h0c-2.89.11-5.79,0.23-8.65,0.38h0a514.11,514.11,0,0,0-58.4,6.33h0c-2.67.45-5.34,0.89-8,1.38h0c-7.94,1.48-15.73,3.2-23.37,5.09h0q-3.81.94-7.57,1.95c-3.76,1,0,0,0,0-2.5.67-5,1.38-7.46,2.09h0c-2.47.72-4.93,1.47-7.36,2.24s-4.86,1.57-7.25,2.38h0c-2.4.81-4.79,1.62-7.15,2.47h0c-4.73,1.71-9.36,3.52-13.94,5.42h0c-2.28.95-4.54,2-6.79,2.95h0c-2.24,1-4.48,2-6.68,3h0c-6.64,3.13-13.06,6.52-19.33,10.08h0c-2.08,1.18-4.13,2.43-6.17,3.66h0c-6.14,3.71-12,7.65-17.77,11.79h0c-1.9,1.38-3.79,2.81-5.65,4.23h0c-1.86,1.43-3.68,2.9-5.49,4.38h0a234.91,234.91,0,0,0-20.68,19,227.39,227.39,0,0,0-22.44,27.25c-1.37,1.95-2.73,3.9-4,5.9-2.62,4-5.16,8.11-7.57,12.32-1.2,2.1-2.38,4.26-3.52,6.42q-3.43,6.48-6.53,13.27c-1,2.27-2,4.58-3,6.9-2.91,7-5.56,14.14-7.93,21.59-0.79,2.49-1.55,5-2.28,7.56a298.05,298.05,0,0,0-7.25,31.82q-1.42,8.3-2.44,16.93a383.45,383.45,0,0,0-2.59,45.32c0,10.68-.12,20.78,0,30.44,0.06,4.83.18,9.52,0.41,14.17,0.12,2.33.24,4.65,0.41,6.94,0.35,4.58.84,9.12,1.5,13.6a144.6,144.6,0,0,0,5.39,23.35c0.71,2.22,1.48,4.43,2.33,6.66a135.74,135.74,0,0,0,6,13.46c0.58,1.13,1.19,2.24,1.81,3.38l0.41,167.31-51.92,18.5a14,14,0,0,0-3.78,2.24h-0.05a21.48,21.48,0,0,0-5.49,7.28,25.87,25.87,0,0,0-1.14,2.85c-0.15.46-.29,1-0.41,1.43s-0.27,1-.36,1.43a19.77,19.77,0,0,0-.41,4.09h0ZM343.8,271.88a34.52,34.52,0,0,0,1.55,9.84l2.49,5.33,59.43-13.17,0.48,189.92C408,582.45,388.68,717.22,392,818.29s46.42,231.51,46.42,231.51l6.27,20.83c8.78,29.33,161.45,39.17,276.55,39.17h11.2c115.1,0,267.77-9.84,276.55-39.14l6.26-20.86s43.11-130.44,46.43-231.51-16-235.85-15.75-354.49l0.47-189.95,59.4,13.2,2.49-5.33a34.52,34.52,0,0,0,1.55-9.84,19.79,19.79,0,0,0-.41-4.09c-0.1-.47-0.23-0.95-0.36-1.43s-0.26-1-.41-1.43a25.89,25.89,0,0,0-1.14-2.85,21.37,21.37,0,0,0-5.44-7.28h0a14,14,0,0,0-3.78-2.24l-51.82-18.5,0.41-167.31c19.8-36.37,17.77-69.26,17.77-112C1064.61-248,921-330.79,730.7-329.83h-7.78C532.58-330.83,389-248,389-45.25c0,42.74-2,75.63,17.77,112l0.41,167.31-51.82,18.5a14,14,0,0,0-3.78,2.24h-0.05a21.37,21.37,0,0,0-5.44,7.28,25.9,25.9,0,0,0-1.14,2.85c-0.15.46-.29,1-0.41,1.43s-0.27,1-.36,1.43a19.8,19.8,0,0,0-.41,4.09h0ZM943.3,591.8a1212.83,1212.83,0,0,0,8.39,144.29c80.77-39,50.18-149.12,52.28-312.83,1-75.62,3.12-136.27,3.94-185C969.22,310,943.3,441.47,943.3,591.8ZM943.3,591.8c0,4.88,0,9.71.1,14.55,26.81-1.25,50.17-9.78,64.41-22.21q-0.2-10.66-.57-22c-13.58,13-36.86,22.21-63.94,23.92v5.74ZM897.31-304.13l1,7.75c4.17,32.79,43.08,57.36,90.42,59.78l11.81,0.57-8-8c-24.34-24.18-53.9-43.07-87.47-56.93ZM915.54,8.68s-37.47-121.26-53-160.37c-16.25-40.85-64.91-150.45-64.91-150.45s70.42,13.3,96,46.39c91,117.52,89.3,354.11,89.3,354.11M881.29-123l3.89,6.75a23.89,23.89,0,0,1,6.37-3.61c19.43-7.3,48.48,16.34,59.33,40.9,0.35,0.79,1.39,2.76,2.75,5.18L947.2-94.47c-14-26.34-38.27-41.81-56.38-35a24.31,24.31,0,0,0-9.53,6.52h0ZM873.89-136l3.89,6.75a23.89,23.89,0,0,1,6.37-3.61c19.43-7.3,48.48,16.34,59.33,40.9,0.35,0.79,1.39,2.76,2.75,5.18l-6.43-20.73c-14-26.34-38.27-41.81-56.38-35a24.31,24.31,0,0,0-9.53,6.52h0ZM871.54-145.43l3.89,6.75a23.89,23.89,0,0,1,6.37-3.61c19.43-7.3,48.48,16.34,59.33,40.9,0.35,0.79,1.39,2.76,2.75,5.18L937.45-117c-14-26.34-38.27-41.81-56.38-35a24.31,24.31,0,0,0-9.53,6.52h0ZM864.46-171.2l3.06,9.42a32,32,0,0,1,9.07-3.09c26.59-4.75,56.85,31.9,63.84,65.49,1.08,5.17,14.22,44,14.6,48.94h6.84L941.73-113.5c-9.11-40-37.22-68.41-63.42-63.73a32.64,32.64,0,0,0-13.84,6h0v0ZM864.46-171.2l3.06,9.42a32,32,0,0,1,9.07-3.09c26.59-4.75,56.85,31.9,63.84,65.49,1.08,5.17,14.22,44,14.6,48.94h6.84L941.73-113.5c-9.11-40-37.22-68.41-63.42-63.73a32.64,32.64,0,0,0-13.84,6h0v0ZM888.95-103.4l3.47,6a21.34,21.34,0,0,1,5.69-3.23c17.36-6.52,43.31,14.6,53,36.54,0.31,0.7,1.25,2.46,2.45,4.63L947.82-78c-12.53-23.53-34.19-37.35-50.36-31.27a21.72,21.72,0,0,0-8.52,5.82h0v0ZM894.87-82.39l3.47,6A21.34,21.34,0,0,1,904-79.62c17.36-6.52,43.31,14.6,53,36.54,0.31,0.7,1.25,2.46,2.45,4.63L953.74-57c-12.53-23.53-34.19-37.35-50.36-31.27a21.72,21.72,0,0,0-8.52,5.82h0v0ZM927.52,846c-3.35-12.62-2.45-23.57,9.6-30.13l29.68,3.79c10.24,10.46,8.21,20.93.26,31.39l-39.53-5h0ZM932.94,815.16c-2-12.4-1-23.08,9.13-28.68l28.24,3.61c4.93,9.87,8.64,19.76.25,29.88l-37.62-4.81h0ZM939.18,591.8a1216.6,1216.6,0,0,0,8.39,144.72l0.67,5.56,5.39-2.62c21-10.15,35-25.2,43.84-44.23s12.62-42,14-68.63c2.74-53.33-4.36-121.68-3.32-203.31,1-75.57,3.12-136.22,3.94-185l-7.88-1.71C964.95,309.41,939.18,441.07,939.18,591.8Zm8.29,0c0-138.75,22.35-261.38,55.91-334.95-1,45.58-2.66,99.24-3.52,166.36-1,82.08,6.06,150.63,3.37,203-1.34,26.2-5.15,48.34-13.37,66.06-7.38,15.91-18.5,28.13-34.67,37.29A1212.36,1212.36,0,0,1,947.47,591.8ZM532.32,804.58L553,922.9c7.22,41.32,80.87,74.49,173.85,77.61,93-3.12,166.63-36.29,173.85-77.61l20.68-118.32c0-20.23-17.75-36.52-39.8-36.52H572.11c-22,0-39.8,16.29-39.8,36.52h0ZM475.57,147.95a57,57,0,0,0,1.61,13.36h0l20.42,97.16c11,27,23.67,48.7,53.06,48.7H903.07c29.4,0,42.11-21.72,53.06-48.7l20.42-97.16h0a57,57,0,0,0,1.61-13.36c0-69.09-95.12-125.09-251.26-125.27-156.15.17-251.26,56.18-251.26,125.27h0ZM510.38,591.8A1212.82,1212.82,0,0,1,502,736.09C421.21,697,451.8,586.93,449.7,423.21c-1-75.62-3.12-136.27-3.94-185C484.45,310,510.38,441.47,510.38,591.8ZM510.38,591.8c0,4.88,0,9.71-.1,14.55-26.81-1.25-50.17-9.78-64.41-22.21q0.2-10.66.57-22c13.58,13,36.86,22.21,63.94,23.92v5.74ZM556.37-304.13l-1,7.75c-4.17,32.79-43.08,57.36-90.42,59.78l-11.81.57,8-8C485.48-268.21,515-287.1,548.61-301ZM538.13,8.68s37.47-121.26,53-160.37C607.38-192.54,656-302.14,656-302.14s-70.42,13.3-96,46.39c-91,117.52-89.3,354.11-89.3,354.11M572.39-123l-3.89,6.75a23.89,23.89,0,0,0-6.37-3.61c-19.43-7.3-48.48,16.34-59.33,40.9-0.35.79-1.39,2.76-2.75,5.18l6.43-20.74c14-26.34,38.27-41.81,56.38-35a24.31,24.31,0,0,1,9.53,6.52h0ZM579.8-136l-3.89,6.75a23.89,23.89,0,0,0-6.37-3.61c-19.43-7.3-48.48,16.34-59.33,40.9-0.35.79-1.39,2.76-2.75,5.18l6.43-20.73c14-26.34,38.27-41.81,56.38-35A24.31,24.31,0,0,1,579.8-136h0ZM582.13-145.43l-3.89,6.75a23.89,23.89,0,0,0-6.37-3.61c-19.43-7.3-48.48,16.34-59.33,40.9-0.35.79-1.39,2.76-2.75,5.18L516.22-117c14-26.34,38.27-41.81,56.38-35a24.31,24.31,0,0,1,9.53,6.52h0ZM589.22-171.2l-3.06,9.42a32,32,0,0,0-9.07-3.09c-26.59-4.75-56.85,31.9-63.84,65.49-1.08,5.17-14.22,44-14.6,48.94H491.8l20.14-63.06c9.11-40,37.22-68.41,63.42-63.73a32.64,32.64,0,0,1,13.84,6h0ZM589.22-171.2l-3.06,9.42a32,32,0,0,0-9.07-3.09c-26.59-4.75-56.85,31.9-63.84,65.49-1.08,5.17-14.22,44-14.6,48.94H491.8l20.14-63.06c9.11-40,37.22-68.41,63.42-63.73a32.64,32.64,0,0,1,13.84,6h0ZM564.73-103.4l-3.47,6a21.34,21.34,0,0,0-5.69-3.23c-17.36-6.52-43.31,14.6-53,36.54-0.31.7-1.25,2.46-2.45,4.63L505.86-78c12.53-23.53,34.19-37.35,50.36-31.27a21.72,21.72,0,0,1,8.52,5.82h0v0ZM558.8-82.39l-3.47,6a21.34,21.34,0,0,0-5.69-3.23c-17.36-6.52-43.31,14.6-53,36.54-0.31.7-1.25,2.46-2.45,4.63L499.93-57c12.53-23.53,34.19-37.35,50.36-31.27a21.72,21.72,0,0,1,8.52,5.82h0v0ZM526.15,846c3.36-12.62,2.45-23.57-9.6-30.13l-29.68,3.79c-10.24,10.46-8.21,20.93-.26,31.39l39.53-5h0ZM520.74,815.16c2-12.4,1-23.08-9.13-28.68l-28.24,3.61c-4.93,9.87-8.64,19.76-.25,29.88l37.62-4.81h0ZM514.5,591.8a1216.61,1216.61,0,0,1-8.39,144.72l-0.67,5.56L500,739.46c-21-10.15-35-25.2-43.84-44.23s-12.62-42-14-68.63c-2.74-53.33,4.36-121.68,3.32-203.31-1-75.57-3.12-136.22-3.94-185l7.88-1.71C488.73,309.41,514.5,441.07,514.5,591.8Zm-8.29,0c0-138.75-22.35-261.38-55.91-334.95,1,45.58,2.66,99.24,3.52,166.36,1,82.08-6.06,150.63-3.37,203,1.34,26.2,5.15,48.34,13.37,66.06,7.38,15.91,18.5,28.13,34.67,37.29A1212.38,1212.38,0,0,0,506.21,591.8Z';

    if ($scope.rideDetails.provider_id === 1) {
      // in case of uber
      scale = 0.02;
      $scope.providerName = 'Uber';
    } else if ($scope.rideDetails.provider_id === 2) {
      scale = 0.02;
      $scope.providerName = 'Lyft';
    } else if ($scope.rideDetails.provider_id === 4) {
      scale = 0.02;
      fillOpacity = 1;
      $scope.providerName = 'External';
    }

    const updateDriverLocation = function updateDriverLocation(message) {
      if (angular.isDefined($scope.movingMarker)) {
        $scope.movingMarker.setMap(null);
        $scope.movingMarker = undefined;
      }

      // in case of completed ride_status,location is null
      if (!message.location_info) return;

      movingLatLng = new google.maps.LatLng(message.location_info.latitude, message.location_info.longitude);

      const mapObj = {
        position: movingLatLng,
        map,
        icon: {
          path,
          scale,
          fillColor,
          fillOpacity,
          strokeWeight: 2,
          strokeOpacity: 0.5,
        },
        label: '',
      };

      if (firstTimeLoad && map) {
        map.setCenter(movingLatLng);
        firstTimeLoad = false;
      }

      if (message.location_info.bearing) {
        mapObj.icon.rotation = message.location_info.bearing;
      }
      $scope.rideDetails.driver_eta = message.location_info.eta;
      $scope.movingMarker = new google.maps.Marker(mapObj);
      $scope.$apply();
    };

    $scope.setFocusOnCar = () => {
      if (angular.isDefined(movingLatLng)) {
        map.setCenter(movingLatLng);
      }
    };

    const clearDriverAlert = () => {
      if (sendingDriverAlertCTAsToServer) {
        toaster.pop({
          type: 'error',
          title: "Can't clear alert, CTA is being updated to server",
          showCloseButton: true,
          timeout: 10000,
        });
        return;
      }

      if (!$scope.driverAlert.ctas.call_driver) {
        toaster.pop({
          type: 'error',
          title: "Can't clear alert, Call Driver CTA is pending",
          showCloseButton: true,
          timeout: 10000,
        });
        return;
      }

      if (!$scope.driverAlert.ctas.call_patient) {
        toaster.pop({
          type: 'error',
          title: "Can't clear alert, Call Rider CTA is pending",
          showCloseButton: true,
          timeout: 10000,
        });
        return;
      }

      const ctaUrl = `${API_BASE_URL}ride/update/${$scope.rideDetails.id}`;

      const params = {
        comments: $scope.rideDetails.comments,
        manually_resolved: true,
        action: 'clear_driver_alert',
        dontupdatedate: true,
        issue_cta: true, // Send extra flag to denote that this action will clear an issue
      };

      if ($scope.rideDetails.variance_type) {
        params.variance_type = $scope.rideDetails.variance_type;
        params.show_in_variance_tab = false;
      }

      const clearAlertCall = $http.put(ctaUrl, params);
      clearAlertCall.then(
        (result) => {
          if (result.data.success) {
            SweetAlert.swal({
              title: 'Trip Updated!',
              text: 'Trip Updated Successfully',
              type: 'success',
            });
            refreshIssuesTab();
            refreshActiveRideTiles();
            $scope.closePopup();
          }
        },
        (err) => {
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    const keepDriverAlertAppt = [
      {
        functionCall: clearDriverAlert,
        buttonDisplayText: 'Clear Alert',
        commentButtonText: 'Confirm Clear Alert',
        type: 'comment',
        show: $scope.oldDashboard,
      },
    ];

    function makeViewChanges() {
      setDriverAlertCTAs();
      checkAndClearETA($scope.rideDetails);
      if ($scope.rideDetails.ride_status === 'Ride Completed') {
        $scope.rideDetails.driver_eta = null;
        $scope.rideDetails.statusType = statusCta[$scope.rideDetails.ride_status].type;
        if ($scope.rideDetails.leg_type === 'round' && $scope.rideDetails.ride_category === 'active') {
          $scope.rideDetails.displayStatus = 'Pending Ride Request';
          $scope.ctas = statusCta.Round.cta;
        } else if ($scope.rideDetails.leg_type === 'multi' && $scope.rideDetails.ride_category === 'active') {
          $scope.rideDetails.displayStatus = 'Pending Ride Request';
          $scope.ctas = statusCta.Multi.cta;
        } else if ($scope.rideDetails.ride_category === 'completed') {
          $scope.ctas = statusCta['Ride Completed'].cta;
        } else {
          $scope.ctas = [];
        }
      }

      if (
        $scope.rideDetails.ride_status !== 'Driver Confirmed'
        && $scope.rideDetails.ride_status !== 'Driver Arrived'
        && $scope.rideDetails.ride_status !== 'Patient Enroute'
        && $scope.rideDetails.ride_status !== 'Late Arrival'
        && $scope.rideDetails.ride_status !== 'Arrival Time Exceeded'
      ) {
        updateDriverLocation({});
      }

      if (
        statusCta[$scope.rideDetails.ride_status]
        && $scope.rideDetails.ride_status !== $scope.ride_status.CONFIRMED.status
        && $scope.rideDetails.ride_status !== $scope.ride_status.RIDE_COMPLETED.status
      ) {
        if (
          $scope.rideDetails.ride_category === 'issue'
          && $scope.rideDetails.late_arrival_flag
          && lateArrivalStatuses.indexOf($scope.rideDetails.ride_status) > -1
        ) {
          $scope.rideDetails.statusType = 'warn';
          $scope.ctas = statusCta['Arrival Time Exceeded'].cta;
        } else if (
          $scope.rideDetails.ride_category === 'issue'
          && $scope.rideDetails.auto_rebook_tries === 2
          && statusCta[`${$scope.rideDetails.ride_status}`].canbeDriverAlert
        ) {
          $scope.rideDetails.statusType = 'danger';
          $scope.rideDetails.driverAlert = '3rd Driver Alert';
          $scope.ctas = keepDriverAlertAppt;
        } else {
          $scope.rideDetails.statusType = statusCta[$scope.rideDetails.ride_status].type;
          $scope.ctas = statusCta[$scope.rideDetails.ride_status].cta;
        }
      }

      if ($scope.rideDetails.ride_status === 'Finding Driver') {
        // pubnubNotificationFactory.subscribeChannel("appt" + $scope.rideDetails.appointment.id);
        // eslint-disable-next-line no-use-before-define
        listenForPubnubMessages();
        setMapPoints();
      }

      if (
        $scope.rideDetails.ride_status === 'Driver Canceled'
        || $scope.rideDetails.ride_status === 'Patient No Show'
        || $scope.rideDetails.ride_status === 'Ride Canceled'
      ) {
        $scope.rideDetails.driver_eta = null;
      }

      if ($scope.rideDetails.ride_status === 'Variance Issue') {
        modifyCTAsForVariance();
        if (
          $scope.rideDetails.leg_type === 'single'
          || ($scope.rideDetails.leg_type === 'round' && $scope.rideDetails.ride_type === 'return')
          || ($scope.rideDetails.leg_type === 'multi' && $scope.rideDetails.leg_no === $scope.rideDetails.appointment.ride_details.length)
        ) {
          $scope.ctas[1].show = false;
        }
      }
      checkAndUpdateCurrentlyViewingAdmins(); // Check for active admins and managed_by mapping
    }

    const statusRefreshBasedOnAppointmentStatus = (payload) => {
      const { message } = payload;
      if (
        message.ride_data
        && (message.appt_id === $scope.rideDetails.appointment.id && message.ride_data.file_no_suffix === $scope.rideDetails.file_no_suffix)
      ) {
        $scope.rideDetails = message.ride_data;
        makeViewChanges();
      }
    };
    $rootScope.$on('activeChannelGroup', (activeChannelGroupEvent, activeChannelGroup) => {
      $scope.rideDetails.activeChannelGroup = activeChannelGroup;
      $rootScope.$on(Pubnub.getMessageEventNameFor(activeChannelGroup), (event, payload) => {
        statusRefreshBasedOnAppointmentStatus(payload);
      });
    });
    function listenForPubnubMessages() {
      const userData = JSON.parse(localStorage.getItem('userDetails'));

      // Attaching presence listener to pubnub service
      Pubnub.removeListener(presenceListeners);
      Pubnub.addListener(presenceListeners);

      // Manually fetching details of active users for the first time... later on it will be handled via pubnub notifications
      setTimeout(() => {
        checkAndUpdateCurrentlyViewingAdmins();
      }, 1000); // Put some delay before fetching here now details...

      $rootScope.$on(Pubnub.getMessageEventNameFor(userData.user_id), (event, payload) => {
        const { message } = payload;
        if (
          message.ride_data
          && (message.appt_id === $scope.rideDetails.appointment.id && message.ride_data.file_no_suffix === $scope.rideDetails.file_no_suffix)
          && (message.ride_data.ride_status === 'Finding Driver'
            || message.ride_data.ride_status === 'Surge Approval Needed'
            || message.ride_data.ride_category === 'issue')
        ) {
          $scope.rideDetails = message.ride_data;
          makeViewChanges();
        }
        if (
          message.ride_data
          && (message.appt_id === $scope.rideDetails.appointment.id && message.ride_data.file_no_suffix === $scope.rideDetails.file_no_suffix)
          && message.ride_data.ride_status === 'Patient Enroute'
        ) {
          $scope.rideDetails = message.ride_data;
          makeViewChanges();
        }
        if (
          message.ride_data
          && message.ride_id === $scope.rideDetails.id
          && message.ride_data.ride_status === 'Variance Issue'
          && message.ride_data.route_lat_long
        ) {
          const refreshForVarianceCall = $http.get(`${API_BASE_URL}ride/getRideDetailsById/${$scope.rideDetails.id}`, {
            params: {
              org_id: userDetails.organisation.id,
            },
          });
          refreshForVarianceCall.then((result) => {
            if (result.data.success) {
              const routeCoordinates = result.data.rideDetails.route_lat_long;
              const routePath = new google.maps.Polyline({
                path: routeCoordinates,
                geodesic: true,
                strokeColor: '#FF0000',
                strokeOpacity: 1.0,
                strokeWeight: 2,
              });
              routePath.setMap(map);
            }
          });
        }
      });
      $rootScope.$on(Pubnub.getMessageEventNameFor($scope.rideDetails.activeChannelGroup), (event, payload) => {
        statusRefreshBasedOnAppointmentStatus(payload);
      });
      $rootScope.$on(Pubnub.getMessageEventNameFor(`appt${$scope.rideDetails.appointment.id}`), (event, payload) => {
        statusRefreshBasedOnAppointmentStatus(payload);
      });
      $rootScope.$on(Pubnub.getMessageEventNameFor(`appt_track${$scope.rideDetails.appointment.id}`), (event, payload) => {
        const { message } = payload;
        if (message.ride_id && message.ride_id === $scope.rideDetails.id) {
          updateDriverLocation(message);
        }
      });
    }

    listenForPubnubMessages();

    $scope.cancel = () => {
      $uibModalInstance.dismiss(false);
      deleteMarkers();
    };

    $scope.showCtas = true;

    $scope.showCommentField = (cta) => {
      $scope.showCtas = false;
      $scope.showComment = true; // Added extra flag for handling show/hide of comment field
      $scope.commentButtonText = cta.commentButtonText;
      commentBoxCta = cta;
    };

    // UI helper to show/hide Active users list
    $scope.toggleActiveUsers = () => {
      $scope.showActiveUsers = !$scope.showActiveUsers;
      $scope.showCtas = !$scope.showActiveUsers;
    };

    $scope.confirmComment = function confirmComment(buttonText) {
      if (
        !['Confirm Notification', 'Confirm Keep Trip', 'Confirm Keep Leg'].includes(buttonText)
        && $scope.rideDetails.leg_type === 'multi'
        && !$scope.rideDetails.driverAlert
        && $scope.rideDetails.leg_no !== $scope.rideDetails.appointment.ride_details.length
        && ![$scope.ride_status.LATE_ARRIVAL.status, $scope.ride_status.REQUEST_OVERDUE.status].includes($scope.rideDetails.ride_status)
      ) {
        let message = 'Are you sure? By clearing the alert you will cancel the subsequent legs of this trip !';
        if ($scope.isGHTRideShare) {
          message = 'Do you want to clear the alert!';
        }
        SweetAlert.swal(
          {
            title: 'Are you sure?',
            text: message,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            closeOnConfirm: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonText: 'No',
          },
          (isConfirm) => {
            if (isConfirm) commentBoxCta.functionCall(buttonText);
          },
        );
      } else {
        commentBoxCta.functionCall(buttonText);
      }
    };

    $scope.cancelConfirm = () => {
      $scope.showCtas = true;
      $scope.showComment = false;
    };
    // stub to fetch all admins
    if (
      $scope.userDetails.role === 'superadmin'
      || $scope.userDetails.role === 'mastersuperadmin'
      || permissionFilter($scope.permissionsConstants.GET_ONLINE_ADMINS)
    ) {
      (function cancelConfirmResult() {
        const urlToFetchAdminsDetails = `${API_BASE_URL}get_all_admins`;
        const getAllAdmins = $http.get(urlToFetchAdminsDetails);
        getAllAdmins.then(
          (result) => {
            if (result.data) {
              $scope.admins = result.data.data;
              // var selectedIndex = $scope.admins.findIndex(x => x.id === $scope.rideDetails.managed_by)

              const selectedIndex = $scope.admins.findIndex(element => element.id === $scope.rideDetails.managed_by);
              if (selectedIndex === -1) {
                const defaultSelected = { id: 0, username: '', first_name: 'Select Admin' };
                $scope.admins.push(defaultSelected);
                $scope.selectedStuff = defaultSelected;
              } else {
                $scope.selectedStuff = $scope.admins[selectedIndex];
              }
            }
          },
          () => {
            $scope.admins = [];
          },
        );
      }());
    }

    // stub to fetche all admins ends here

    // stub to update the admin manager for issue/alert
    // $scope.selectedStuff = $scope.rideDetails.managed_by

    $scope.updateManager = () => {
      // update manager
      const adminId = $scope.selectedStuff.id;
      const urlToUpdateMangerOfRide = `${API_BASE_URL}update_ride_manager`;
      if (adminId <= 0) {
        toaster.pop({
          type: 'error',
          title: 'select an admin',
          showCloseButton: true,
          timeout: 10000,
        });
        return;
      }
      const params = {
        adminId,
        rideId: $scope.rideDetails.id,
        orgId: $scope.rideDetails.org_id,
      };
      const updateManager = $http.put(urlToUpdateMangerOfRide, params);

      updateManager.then(
        (result) => {
          // var adminObjIndex = $scope.admins.findIndex(x => x.id === $scope.selectedStuff.id)
          // const adminObjIndex = $scope.admins.findIndex(element => element.id === $scope.selectedStuff.id);
          refreshIssuesTab();
          refreshActiveRideTiles();
          if (result) {
            SweetAlert.swal({
              title: 'Ride manager updated',
              text: 'Ride manager updated successfully',
              type: 'success',
            });
          }
        },
        (err) => {
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };
    // stub to update the admin manager ends here

    const keepRequestOverdueAppointment = () => {
      const ctaUrl = `${API_BASE_URL}ride/update/${$scope.rideDetails.id}`;
      const params = {
        comments: $scope.rideDetails.comments,
        ride_status: _.get($scope.rideDetails, 'ride_additional_detail.previous_state.ride_status', statuses.RIDE_COMPLETED.status),
        ride_category: 'active',
        action: 'request_overdue_kept',
        dontupdatedate: true,
        // Send extra flag to denote that this action will clear an issue
        issue_cta: true,
      };

      if ($scope.rideDetails.variance_type) {
        params.variance_type = $scope.rideDetails.variance_type;
        params.show_in_variance_tab = false;
      }

      const clearAlertCall = $http.put(ctaUrl, params);
      clearAlertCall.then(
        (result) => {
          if (result.data.success) {
            SweetAlert.swal({
              title: 'Issue Addressed!',
              text: 'Issue Addressed Successfully',
              type: 'success',
            });
            refreshIssuesTab();
            refreshActiveRideTiles();
            $scope.closePopup();
          }
        },
        (err) => {
          if (err) {
            toaster.pop({
              type: 'error',
              title: err.data.message,
              showCloseButton: true,
              timeout: 10000,
            });
          }
        },
      );
    };

    $scope.openSurgeModal = () => {
      $rootScope.$broadcast('approveSurgePricing', {
        higher_price_confirmation_url: $scope.rideDetails.higher_price_confirmation_url,
        afterApprovalFunction: approveSurgePricing,
      });
    };

    // type:action - that directly hits api
    // type:comment - that first opens text area and then hits api

    const keepAppointmentForRequestOverDue = [
      {
        functionCall: keepRequestOverdueAppointment,
        buttonDisplayText: 'Keep Trip',
        commentButtonText: 'Confirm Keep Trip',
        type: 'comment',
        show: $scope.oldDashboard,
      },
    ];

    const ctaKeys = Object.keys(statusCta);
    for (let ctaIndex = 0; ctaIndex < ctaKeys.length; ctaIndex += 1) {
      const ctaKey = ctaKeys[ctaIndex];
      if (ctaKey === $scope.rideDetails.ride_status) {
        if (
          $scope.rideDetails.ride_category === 'issue'
          && $scope.rideDetails.late_arrival_flag
          && lateArrivalStatuses.indexOf($scope.rideDetails.ride_status) > -1
        ) {
          $scope.rideDetails.statusType = 'warn';
        } else if ($scope.rideDetails.ride_category === 'issue' && $scope.rideDetails.auto_rebook_tries === 2 && statusCta[ctaKey].canbeDriverAlert) {
          $scope.rideDetails.statusType = 'danger';
          $scope.rideDetails.driverAlert = '3rd Driver Alert';
        } else {
          $scope.rideDetails.statusType = statusCta[ctaKey].type;
        }
        break;
      }
    }
    if ($scope.rideDetails.ride_status === 'Ride Completed' || ($scope.isGHTRideShare && ($scope.rideDetails.ride_status === 'Provider No Show' || $scope.rideDetails.ride_status === 'Patient No Show'))) {
      $scope.rideDetails.driver_eta = null;
      if ($scope.rideDetails.leg_type === 'round' && $scope.rideDetails.ride_category === 'active') {
        $scope.rideDetails.displayStatus = 'Pending Ride Request';
      }
      if ($scope.rideDetails.leg_type === 'multi' && $scope.rideDetails.ride_category === 'active') {
        $scope.rideDetails.displayStatus = 'Pending Ride Request';
      }
    }

    if (
      $scope.rideDetails.ride_category === 'issue'
      && $scope.rideDetails.late_arrival_flag
      && lateArrivalStatuses.indexOf($scope.rideDetails.ride_status) > -1
    ) {
      $scope.ctas = statusCta['Arrival Time Exceeded'].cta;
    } else if ($scope.rideDetails.driverAlert) {
      $scope.ctas = keepDriverAlertAppt;
    } else if ($scope.rideDetails.ride_status === $scope.ride_status.VARIANCE_ISSUE.status) {
      $scope.ctas = statusCta[$scope.rideDetails.ride_status].cta;
      modifyCTAsForVariance();
    } else if ($scope.rideDetails.displayStatus !==  'Pending Ride Request' && $scope.rideDetails.ride_status !== 'Request Overdue') {
      $scope.ctas = statusCta[`${$scope.rideDetails.ride_status}`].cta;
    } else if ($scope.rideDetails.ride_status === 'Request Overdue') {
      if ($scope.rideDetails.leg_type === 'round') {
        $scope.ctas = keepAppointmentForRequestOverDue.concat(statusCta.Round.cta);
      } else if ($scope.rideDetails.leg_type === 'multi') {
        $scope.ctas = keepAppointmentForRequestOverDue.concat(statusCta.Multi.cta);
      }
    } else if ($scope.rideDetails.leg_type === 'round' && $scope.rideDetails.ride_category === 'active') {
      $scope.ctas = statusCta.Round.cta;
    } else if ($scope.rideDetails.leg_type === 'multi' && $scope.rideDetails.ride_category === 'active') {
      $scope.ctas = statusCta.Multi.cta;
    } else if ($scope.rideDetails.displayStatus === 'Pending Ride Request' && $scope.rideDetails.ride_category === 'completed') {
      $scope.ctas = statusCta['Ride Completed'].cta;
    } else {
      $scope.ctas = [];
    }

    $rootScope.$on('refreshActiveRideModal', () => {
      refreshPopupFromApi();
    });

    $scope.getEtaLabel = () => {
      if ($scope.rideDetails.ride_status === 'Patient Enroute' || $scope.rideDetails.ride_status === 'Late Arrival') {
        return 'ESTIMATED TIME TO DESTINATION';
      }
      return 'ESTIMATED TIME OF ARRIVAL';
    };

    $scope.callDriverPanel = false;
    $scope.showCallDriverPannel = () => {
      $scope.callDriverPanel = true;
    };
    $scope.hideCallDriverPannel = () => {
      $scope.callDriverPanel = false;
    };
    $scope.callDriver = () => {
      const call = this.adminNumber;
      const callee = $scope.rideDetails.driver_phone;
      const urlToBridgeCalls = `${API_BASE_URL}bridge-calls`;
      const data = {
        caller: call,
        callee,
        provider_user_id: $scope.rideDetails.providers_user.id,
        ride_id: $scope.rideDetails.id,
      };
      const callBridge = $http.post(urlToBridgeCalls, data);
      callBridge.then(
        (result) => {
          if (result.data.success) {
            SweetAlert.swal({
              title: 'Call connected',
              text: result.data.message,
              type: 'success',
            });
          } else {
            SweetAlert.swal({
              title: 'Not connected',
              text: 'one or more wrong number supplied',
              type: 'error',
            });
          }
        },
        () => {
          SweetAlert.swal({
            title: 'Call Status',
            text: 'error',
            type: 'error',
          });
        },
      );
    };

    $scope.getLegStatus = (legDetails) => {
      if (
        legDetails.ride_category === 'completed'
        || legDetails.ride_status === $scope.ride_status.RIDE_COMPLETED.status
        || ($scope.isMasRide && legDetails.ride_status === $scope.ride_status.REQUEST_OVERDUE.status)
      ) {
        return 'Completed';
      }
      if (legDetails.ride_status === $scope.ride_status.PENDING_DISPOSITION.status
      ) {
        return $scope.ride_status.PENDING_DISPOSITION.status;
      }
      if (legDetails.ride_category === 'active' || (legDetails.ride_category === 'issue' && legDetails.ride_status === 'Driver Arrived')) {
        return 'In - Progress';
      }
      if (legDetails.ride_category === 'issue') {
        return 'Issue';
      }
      return 'Edit Details';
    };

    $scope.getLegStyle = (legDetails) => {
      const style = { 'font-weight': 'bold' };
      if (
        legDetails.ride_category === 'completed'
        || legDetails.ride_status === $scope.ride_status.RIDE_COMPLETED.status
        || ($scope.isMasRide && legDetails.ride_status === $scope.ride_status.REQUEST_OVERDUE.status)
      ) {
        style.color = statusColor.info;
      } else if (legDetails.ride_status === statuses.PENDING_DISPOSITION.status) {
        style.color = statusColor.success;
      } else if (legDetails.ride_category === 'active' || (legDetails.ride_category === 'issue' && legDetails.ride_status === 'Driver Arrived')) {
        style.color = statusColor.warn;
      } else {
        style.color = statusColor.danger;
      }
      return style;
    };

    $scope.goToCreateRidePage = function goToCreateRidePage(ride, externalOrderId, editRideDetails) {
      if (
        ride.ride_category === 'completed'
        || ride.ride_status === $scope.ride_status.RIDE_COMPLETED.status
        || ($scope.isMasRide && ride.ride_status === $scope.ride_status.REQUEST_OVERDUE.status)
      ) {
        return;
      }
      $scope.closePopup();
      const organisationType = editRideDetails.appointment.organisation.org_type;
      let state = externalOrderId ? 'main.dashboard.rideOrderDetails' : 'main.dashboard.createAppointment';

      if (organisationType === 'mas') {
        state = 'main.dashboard.masOrderDetails';
      }
      $state.go(state, {
        rideId: ride.id,
        caller,
      });
    };
    /**
     * return provider number for display on basis on agency or individual provider
     */
    $scope.getProviderPhone = function getProviderPhone(vendorDetail = {}) {
      if (
        vendorDetail.transportation_type === String(transportationTypeConsts.sp)
      ) {
        return vendorDetail.cell_phone;
      }
      return vendorDetail.phone;
    };
  },
]);
